import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#085F99", //darkblue
    },
    background: {
      default: "#FFFFFF",
      paper: "#f5f5f5",
      full: "#E6F3F9", //light blue
      g_model: "#E3E3E3",
      forward: "#F0F0F2",
      ticket: "#F7FAFF",

      chatList: "#085F991C",
      chatwindow: "#FFFFFF",
    },
    text: {
      primary: "#3F3F3F", //light black
      gray: "#6D6A6A",
      ticket: "#858585",
    },
    icon: {
      primary: "#085F99",
      black: "#121212",
      chat_nav: "#0D406F",
    },
    active: {
      primary: "#D3D3D3",
    },
    search: {
      main: "rgb(241,241,241)",
    },
    hover: {
      main: "#f0f0f0",
      side: "#c2d7f0",
      contact: "#D3D3D3",
      folder: "#f5f5f5",
      group: "#EDF8FF",
    },
    newMail: "#e9e9e9",
    reply: "gray",
    input: {
      primary: "#E4EDF4",
    },
    call: "#081C27",
    chat: "#dce9f2",
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#085F99", //dark blue for button and text
    },
    secondary: {
      main: "#FF4081", // Pink for secondary actions
    },
    background: {
      default: "#121212", //black
      paper: "#1E1E1E", //light black
      g_model: "#bcbcbc",
      forward: "#5c5c5c",
      ticket: "#121212",

      chatList: "#1E1E1E",
      chatwindow: "#010101",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#3F3F3F", //light black
      gray: "#FFFFFF",
      ticket: "#FFFFFF",
    },
    icon: {
      primary: "#FFFFFF",
      black: "#FFFFFF",
      chat_nav: "#FFFFFF",
    },
    active: {
      // primary: "#535353",
      primary: "#085F99",
    },
    search: {
      main: "#3F3F3F",
    },
    hover: {
      main: "#595959",
      side: "#1E1E1E",
      contact: "#575757",
      folder: "#1E1E1E",
      group: "#1E1E1E",
      message: "#085F99",
    },
    newMail: "#3F3F3F",
    reply: "#ffffff",
    input: {
      primary: "#3F3F3F",
    },
    call: "#3F3F3F",
    chat: "#1E1E1E",
  },
});
